module.exports = __webpack_public_path__ + "img/icon-apple-pay.cf6318aa.svg";